export default "__VITE_ASSET__BIV6gMyQ__"